import React from "react";
import EditIcon from "@material-ui/icons/EditOutlined";
import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import locale from "@bonliva-crm/locale";
import { EventLog_CustomerEventFragment as Event } from "@graphql";
import { ButtonOptions, FloatingMenu } from "@components/FloatingMenu";

type Props = {
  event: Event;
  onEdit: () => void;
  onDelete: () => void;
  className?: string;
};

export function CustomerEventFloatingMenu(props: Props) {
  const { className, event } = props;
  const buttons: ButtonOptions[] = [];

  if (event.CanEdit) {
    buttons.push({
      key: "edit-log-item",
      icon: <EditIcon fontSize="inherit" />,
      onClick: props.onEdit,
      title: locale.Edit,
      titleDisabled: locale.NoPermissions,
      disabled: false
    });
  }

  if (event.CanDelete) {
    buttons.push({
      key: "delete-log-item",
      icon: <DeleteIcon fontSize="inherit" />,
      onClick: props.onDelete,
      title: locale.Delete,
      titleDisabled: locale.NoPermissions,
      disabled: !event.CanDelete
    });
  }

  return <FloatingMenu className={className} buttons={buttons} />;
}
